import animator from 'canvas-animator'
import resource from './resource'
import * as global from '../global'

export default class TitleWord extends animator.shapes.Bitmap {
  constructor (context = null, x = 0, y = 0, word) {
    super(context, x, y, TitleWord.width, TitleWord.height, resource[`title-${word}`])
    this.alpha = 0
    this.show = false
  }

  update (elapsed) {
    super.update(elapsed)
    if (this.show && this.alpha < 1) {
      this.alpha += elapsed // / n seconds
    }
  }
}
TitleWord.width = 84 * global.scale
TitleWord.height = 84 * global.scale
